import { Card, CardContent, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import "@features/Alert/css/AlertListPage.scss";
import { Alert } from "@features/Alert/Alert";
import { useAlertList } from "@features/Alert/hook/useAlertList";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { Pagination } from "@common/Pagination/Pagination";

export const AlertListPage = () => {
    const { alertList, getAlertList, getAlertListState, currentPage, setCurrentPage, totalPages } = useAlertList();
    const { t } = useTranslation(["navigation", "alerts"]);

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed alerts-page">
                <Typography align="center" color="secondary" variant="h1">
                    {t("navigation:myAlerts")}
                </Typography>
                <HandleErrorAndLoading
                    error={getAlertListState.error}
                    isLoading={getAlertListState.isLoading}
                    retryFetch={getAlertList}
                >
                    {alertList.length === 0 && (
                        <Card elevation={2}>
                            <CardContent>
                                <Typography align="center" color="secondary" variant="h5">
                                    {t("alerts:noAlert")}
                                </Typography>
                            </CardContent>
                        </Card>
                    )}
                    <div>
                        {alertList.map((alert) => (
                            <Alert alert={alert} getAlertList={getAlertList} key={alert.id} />
                        ))}
                        {alertList.length !== 0 && (
                            <Pagination
                                currentPage={currentPage}
                                setCurrentIndex={setCurrentPage}
                                totalPages={totalPages}
                            />
                        )}
                    </div>
                </HandleErrorAndLoading>
            </div>
        </Fragment>
    );
};
